import React from "react";
import { CaptionProp } from "../../../@types/react-table";
import { useTranslate } from "../../../helpers";

/**
 * useSubSectionCaption renders the section title and a help text below it.
 * @param titleID the phrase key for the title
 * @param helpTextID the phrase key for the help text
 * @returns CaptionProp
 */
export const useSubSectionCaption = (
  titleID: string,
  helpTextID: string
): CaptionProp => {
  const t = useTranslate();
  return {
    title: t(titleID),
    render: function renderTableCaption(title: JSX.Element) {
      return (
        <>
          {title}
          <p className="ds-u-margin-y--1">{t(helpTextID)}</p>
        </>
      );
    },
  } as CaptionProp;
};
